// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"167":"95fef1c5f9481c9d","642":"80fa7644db0eec0a"}[chunkId] + ".js";
};